import { createFileRoute } from "@tanstack/react-router";

import { StorefrontSettingsPage } from "../../../features/storefront/storefront-settings-page";

export const Route = createFileRoute("/_app/settings/online-store")({ component: StorefrontSettingsPage });
